// Who dispatches the package at the origin, as the API expects it
// (pre_package.origin_contact). It is optional: with no name and no phone the key is omitted, so
// a service created without it is exactly the request that was sent before this field existed.
export const buildOriginContact = (originContact) => {
  const name = (originContact?.name || '').trim();
  const phone = (originContact?.phone || '').replace(/\s/g, '');
  if (!name && !phone) return undefined;

  return {
    name: name || undefined,
    phone: phone || undefined,
    country_code: phone ? originContact.country_code : undefined,
  };
};
